import React from "react";
import { Grid, Link, useMediaQuery } from "@material-ui/core";
import PropTypes from "prop-types";
import { Logo } from "src/atoms/index.js";
import { Toolbar } from "src/molecules/index.js";
import { useTheme } from "@material-ui/core/styles";

const Navbar = ({ children, history, pageIndex }) => {
  const theme = useTheme();
  const mediumResolution = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <Toolbar>
      <Grid container alignItems="center">
        <Grid item xs={3}>
          <Link onClick={() => history?.push("/")}>
            <Logo
              size={mediumResolution ? "small" : "extra-small"}
              variant="full"
            />
          </Link>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

Navbar.propTypes = {
  history: PropTypes.object,
  pageIndex: PropTypes.number,
  children: PropTypes.array,
};

export { Navbar };
